import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import ImageContainer from "./components/ImageContainer";
import VideoContainer from "./components/VideoContainer";
import lang from "./utils/lang";
import toast from "./utils/toast";
import routing from "./utils/routing";

// import styles
import "./assets/css/styles.scss";

function loadMarketingScripts() {
  // Google Ads
  if (!document.getElementById('adsbygoogle-script')) {
    const adsScript = document.createElement('script');
    adsScript.id = 'adsbygoogle-script';
    adsScript.async = true;
    adsScript.src = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6470618638542568';
    adsScript.crossOrigin = 'anonymous';
    document.head.appendChild(adsScript);
  }

  // Facebook Pixel
  if (!window.fbq) {
    (function(f,b,e,v,n,t,s) {
      if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)
    })(window, document,'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', '1586597318715811');
    window.fbq('track', 'PageView');
    
    // Process any queued events
    if (window.fbqEvents && window.fbqEvents.length > 0) {
      window.fbqEvents.forEach(event => {
        if (event.type === 'track') {
          window.fbq('track', event.eventName, event.params);
        } else if (event.type === 'trackCustom') {
          window.fbq('trackCustom', event.eventName, event.params);
        }
      });
      // Clear the queue
      window.fbqEvents = [];
    }
  }
}

function loadStatisticsScripts() {
  // Google Tag Manager
  if (!document.getElementById('gtm-script')) {
    const gtmScript = document.createElement('script');
    gtmScript.id = 'gtm-script';
    gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-NW32VLM');`;
    document.head.appendChild(gtmScript);
  }

  // Google Analytics
  if (!document.getElementById('ga-script')) {
    const gaScript = document.createElement('script');
    gaScript.id = 'ga-script';
    gaScript.async = true;
    gaScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-3CVW2B9ZBC';
    document.head.appendChild(gaScript);
    gaScript.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag(){window.dataLayer.push(arguments);}
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', 'G-3CVW2B9ZBC');
    };
  }
}

function loadPreferencesScripts() {
  // Hotjar
  if (!window.hj) {
    (function(h,o,t,j,a,r){
      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
      h._hjSettings={hjid:3482281,hjsv:6};
      a=o.getElementsByTagName('head')[0];
      r=o.createElement('script');r.async=1;
      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
      a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
  }
}



function loadNonEssentialScripts(preferences = true, statistics = true, marketing = true) {
  if (preferences) {
    loadPreferencesScripts();
  }
  
  if (statistics) {
    loadStatisticsScripts();
  }
  
  if (marketing) {
    loadMarketingScripts();
  }
}

function removeMarketingScripts() {
  // Remove Google Ads
  const adsScript = document.getElementById('adsbygoogle-script');
  if (adsScript) adsScript.remove();
  
  // Remove Facebook Pixel
  if (window.fbq) {
    window.fbq = undefined;
  }
  
  // Clear any queued events
  if (window.fbqEvents) {
    window.fbqEvents = [];
  }
}

function removeStatisticsScripts() {
  // Remove Google Tag Manager
  const gtmScript = document.getElementById('gtm-script');
  if (gtmScript) gtmScript.remove();
  
  // Remove Google Analytics
  const gaScript = document.getElementById('ga-script');
  if (gaScript) gaScript.remove();
  
  // Remove Google Analytics global
  if (window.gtag) {
    window.gtag = undefined;
  }
}

function removePreferencesScripts() {
  // Remove Hotjar
  if (window.hj) {
    window.hj = undefined;
  }
}



function removeNonEssentialScripts(preferences = true, statistics = true, marketing = true) {
  if (preferences) {
    removePreferencesScripts();
  }
  
  if (statistics) {
    removeStatisticsScripts();
  }
  
  if (marketing) {
    removeMarketingScripts();
  }
}

const COOKIE_KEY = 'cookie_consent';
const COOKIE_PREFERENCES = 'cookie_preferences';
const COOKIE_STATISTICS = 'cookie_statistics';
const COOKIE_MARKETING = 'cookie_marketing';

function handleConsent() {
  const consent = localStorage.getItem(COOKIE_KEY);
  if (consent === 'accepted' || consent === 'customized') {
    const preferences = localStorage.getItem(COOKIE_PREFERENCES) === 'true';
    const statistics = localStorage.getItem(COOKIE_STATISTICS) === 'true';
    const marketing = localStorage.getItem(COOKIE_MARKETING) === 'true';
    
    loadNonEssentialScripts(preferences, statistics, marketing);
  } else {
    removeNonEssentialScripts(true, true, true);
  }
}

window.addEventListener('cookie-consent', (e) => {
  if (e.detail && e.detail.consent) {
    const preferences = e.detail.preferences === true;
    const statistics = e.detail.statistics === true;
    const marketing = e.detail.marketing === true;
    
    loadNonEssentialScripts(preferences, statistics, marketing);
  } else {
    removeNonEssentialScripts(true, true, true);
  }
});

handleConsent();

// RD Station script now loaded via index.html to avoid conflicts
// loadRDStationScript();

// RD Station should automatically track page views once loaded
// No manual tracking needed if script is properly implemented

createApp(App)
  .use(router)
  .use(lang)
  .use(toast)
  .use((app) => {
    app.component("ImageContainer", ImageContainer);
    app.component("VideoContainer", VideoContainer);
    app.mixin(routing);
  })
  .mount("#app");
